import React, { useRef } from 'react'
import { ArrowRight } from '../../../../constants/svg'
import ImgUtil from '../../../../utils/img.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import Button from '../../../global/button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'
import {
  AccordionLayoutVariantStyle,
  ColumnLayoutVariantStyle,
  TabLayoutVariantStyle,
} from '../style'
import { AccordionLayout } from './accordionLayout'
import { ColumnLayoutVariant } from './columnLayout'
import { TabsLayout } from './tabsLayout'

type AccordionImageProps = {
  id: number
  isOpen: boolean
  tabImgAlt: string
  tabImgPath: string
  mainImgPath: string
  mainImgAlt: string
}

type AccordionItemProps = {
  id: number
  title: string
  headline: string
  body: {
    raw: string
  } | null
  tabImgAlt: string
  tabImgPath: string
  mainImgPath: string
  mainImgAlt: string
  isOpen: boolean
  onClick: () => void
  ctaLink: string
  ctaText: string
}

export const renderMediaTextVariant = ({ useCaseData }: any, pageType: string) => {
  const mainImgProps = {
    mainImgPath: useCaseData?.mainImgPath,
    mainImgAlt: useCaseData?.mainImgAlt,
  }

  let dataUseCase = useCaseData?.useCase
  // Page Solution - Tabs Usecase Only
  if (pageType === 'solutions') {
    dataUseCase = 'Tabs'
  }

  switch (dataUseCase) {
    case 'Tabs':
      return (
        <TabLayoutVariantStyle $pageType={pageType || ''}>
          <TabsLayout mtvData={useCaseData?.tabsLayout} {...mainImgProps}></TabsLayout>
        </TabLayoutVariantStyle>
      )
    case 'Accordions':
      return (
        <AccordionLayoutVariantStyle>
          <AccordionLayout
            mtvData={useCaseData?.accordionsLayout}
            {...mainImgProps}></AccordionLayout>
        </AccordionLayoutVariantStyle>
      )
    default:
      return (
        <>
          <ColumnLayoutVariantStyle>
            <ColumnLayoutVariant mtvData={useCaseData?.columnsLayout} {...mainImgProps} />
          </ColumnLayoutVariantStyle>
        </>
      )
  }
}

export const AccordionImage = ({
  id,
  isOpen,
  tabImgAlt,
  tabImgPath,
  mainImgPath,
  mainImgAlt,
}: AccordionImageProps) => {
  return (
    <WrapperImage
      key={id}
      src={ImgUtil.getResizedImageUrl(tabImgPath ? tabImgPath : mainImgPath, `height=600`)}
      alt={tabImgAlt ? tabImgAlt : mainImgAlt}
      threshold={650}
      className={`Accordion-image ${isOpen ? 'active' : ''}`}
    />
  )
}

export const AccordionItem = ({
  id,
  title,
  headline,
  body,
  tabImgAlt,
  tabImgPath,
  mainImgPath,
  mainImgAlt,
  isOpen,
  onClick,
  ctaLink,
  ctaText,
}: AccordionItemProps) => {
  const contentHeight = useRef<any>()

  return (
    <div className="Item" key={id}>
      <button className={`Accordion__Content-text ${isOpen ? 'active' : ''}`} onClick={onClick}>
        <div>
          <ArrowRight />
        </div>
        {title}
      </button>
      <div
        ref={contentHeight}
        className="answer-container"
        style={isOpen ? { height: contentHeight.current.scrollHeight } : { height: '0px' }}>
        <Typography type="header3" className="Accordion__Content-title">
          {formatInlineCode(headline)}
        </Typography>
        {body && (
          <Typography type="bodyXL" className="Accordion__Content-desc font__inter">
            {renderRichText(body)}
          </Typography>
        )}
        {ctaLink && (
          <Button
            icon={true}
            href={ctaLink}
            text={ctaText}
            type="text-link"
            size="small"
            theme={'light'}
          />
        )}
        <AccordionImage
          id={id}
          isOpen={true}
          tabImgAlt={tabImgAlt}
          tabImgPath={tabImgPath}
          mainImgPath={mainImgPath}
          mainImgAlt={mainImgAlt}
        />
      </div>
    </div>
  )
}
